import React from 'react';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';

const IbAndAp = () => {
  return (
    <>
      <div className='p-5 lg:p-12 bg-waves bg-cover lg:px-36 min-h-screen space-y-3 lg:grid grid-cols-2'>
        <div>
          <motion.div
            animate={{ x: 0 }}
            initial={{ x: -500 }}
            transition={{ delay: 0.1 }}
          >
            <h3 className='text-black mb-4 text-4xl font-bold lg:text-left md:text-center lg:pl-12'>
              International Baccalaureate Programme (IB) and Advanced Placement
              (AP)
            </h3>
          </motion.div>
          <div className='lg:py-4 lg:pr-12'>
            <div className='bg-white p-6 rounded-lg shadow-lg text-left flex-col'>
              <p className='text-black sm:text-justify md:text-xl'>
                Link & Learn offers lessons for all courses for students
                enrolled in the International Baccalaureate Programme (IB) as
                well as students enrolled in Advanced Placement (AP) courses. In
                addition to gaining invaluable guidance through all upper level
                academic courses, students enrolled in our IB program will
                thrive in a one on one environment allowing them to gain
                insights from their teacher to prepare for success at university
                and life by developing intellectual, social, emotional and
                physical well-being attributes. Our teachers will prepare IB
                students for all the demanding elements of the Diploma Programme
                including the final IB examinations. For students taking
                advanced placement courses, our teachers also offer classes in:
              </p>
              <ol className='list-decimal sm:text-justify pl-12 text-left md:text-xl mt-3'>
                <li>AP Calculus</li>
                <li>AP Biology</li>
                <li>AP Chemistry</li>
                <li>AP Physics</li>
                <li>AP European History</li>
                <li>AP English Literature & Composition</li>
              </ol>
            </div>
          </div>
        </div>
        <div className='lg:pr-12'>
          <img
            className='sm:mx-auto h-auto rounded-3xl drop-shadow-2xl 2xl:mt-9 lg:mt-24'
            src='/ib.png'
            alt=''
          />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default IbAndAp;
